import { render, staticRenderFns } from "./BConfirm.vue?vue&type=template&id=07ec8d93&"
import script from "./BConfirm.vue?vue&type=script&lang=js&"
export * from "./BConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports